import styled from 'styled-components'

export const CustomPhysiologyContainer = styled.ul`
  font-size: 16px;
  line-height: 30px;
  color: var(--grey14);
  list-style-position: inside;
  margin-top: 2rem;
`
